import { pingOk } from '@/modules/fetch-core';

// Health probe for gateway-outage recovery polling.
export function pingSanrApi(): Promise<boolean> {
  return pingOk(`${import.meta.env.VITE_BACKEND_URL_API}/ping`);
}
